import { z } from 'zod';

export const statusUpdateBlockSchema = z.object({
    blockId: z.uuid(),
    label: z.string(),
    finished: z.boolean().default(false),
    type: z.literal('status-update'),
});

export type StatusUpdateBlock = z.infer<typeof statusUpdateBlockSchema>;
